import angular from "angular";
import { IGridSettings } from "../../grids/settings/gridSettingsService";
import { ColDef } from "../../grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../../grids/controller";
import { SelectRecordModalConfig } from "./service";

export class SelectRecordModalComponentController {
  static $inject = [ColumnDefinitionServiceName];

  title: string = "";
  columns: ColDef[] = [];
  gridSettings!: IGridSettings;

  /*bindings*/
  resolve!: { config: SelectRecordModalConfig };
  modalInstance!: angular.ui.bootstrap.IModalInstanceService;
  /*end bindings*/

  constructor(
    private readonly columnDefinitionService: ColumnDefinitionService
  ) {
    this.setModalWidth("950px");
  }

  $onInit(): void {
    const config = this.resolve?.config ?? {};
    const gridConfiguration = config.gridConfiguration;

    this.title = config.title;
    this.columns = [
      this.columnDefinitionService.getCommandColDef({
        headerName: "select",
        iconClass: "fa fa-plus-circle text-primary",
        name: "select",
      }),
      ...(gridConfiguration.columns ?? []),
    ];
    this.gridSettings = gridConfiguration.gridSettings!;
  }

  onItemCommand(args: IRowCommandEventArgs<any>) {
    if (args.commandName === "select") {
      this.resolve?.config?.onItemSelected(args.data, this.modalInstance);
    }
  }

  cancel() {
    this.modalInstance.dismiss("cancel");
  }

  private setModalWidth(width: string) {
    const elements = document.querySelector(".modal-content");
    if (!elements) return;
    var modalWindow = angular.element(elements);
    modalWindow.css("width", width);
  }
}
